import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {DxDataGridComponent, DxToolbarComponent} from 'devextreme-angular';
import moment from 'moment';
import {FieldsGeneralReportRequest} from '../fields-general-report/fields-general-report.component';
import {FieldService} from '../../stores/field.service';
import {TrailerOperationTypeService} from '../../stores/trailer-operation-type.service';
import {Field, TrailerOperationType} from 'shared';

@Component({
  selector: 'app-fields-general-report-toolbar',
  templateUrl: './fields-general-report-toolbar.component.html',
  styleUrls: ['./fields-general-report-toolbar.component.scss']
})
export class FieldsGeneralReportToolbarComponent implements OnInit {

  @ViewChild(DxToolbarComponent, {static: true})
  toolbar: DxToolbarComponent;

  @Input()
  grid?: DxDataGridComponent;

  @Input()
  request: FieldsGeneralReportRequest;

  @Output()
  generate = new EventEmitter<FieldsGeneralReportRequest>();

  generateButtonOptions: any;
  exportButtonOptions: any;
  currentFilter = 2;
  isDropDownBoxOpened = false;


  dateFilters: any = [
    {value: 0, label: 'Période Personnalisée'},
    {value: 1, label: 'Dernière heure'},
    {value: 2, label: 'Aujourd\'hui'},
    {value: 3, label: 'Hier'},
    {value: 4, label: 'Avant hier'},
    {value: 5, label: 'Il y a 3 jours'},
    {value: 6, label: 'Cette Semaine'},
    {value: 7, label: 'La Semaine Dernière'},
    {value: 8, label: 'Ce Mois'},
    {value: 9, label: 'Le Mois Dernier'},
  ];

  loadingVisible = true;
  fields: Field[];
  operationTypes: TrailerOperationType[];

  constructor(
    private fieldService: FieldService,
    private trailerOperationTypeService: TrailerOperationTypeService,
  ) {
    // Bindings
    this.dateFilterChanged = this.dateFilterChanged.bind(this);
    this.dateChanged = this.dateChanged.bind(this);

    this.generateButtonOptions = {
      icon: 'repeat',
      text: 'Génerer',
      onClick: () => {
        this.generate.emit(this.request);
      }
    };

    this.exportButtonOptions = {
      icon: 'xlsxfile',
      text: 'Exporter',
      onClick: () => {
        this.grid.instance.exportToExcel(false);
      }
    };

    const fieldsDs = fieldService.newDataSource({
      paginate: false,
    });
    const trailerOperationTypeDs = trailerOperationTypeService.newDataSource({
      paginate: false,
    });

    Promise.all([fieldsDs.load(), trailerOperationTypeDs.load()]).then(_ => {
      this.fields = fieldsDs.items();
      this.operationTypes = trailerOperationTypeDs.items();
      this.loadingVisible = false;
    });
  }

  ngOnInit(): void {
  }

  dateFilterChanged(e) {
    this.request.isToday = false;
    if (this.currentFilter === 0 || e.value === 0) {
      setTimeout(() => {
        this.toolbar.instance.repaint();
      }, 100);
    }
    this.currentFilter = e.value;
    switch (e.value) {
      case 1:
        this.request.from = moment().subtract(1, 'hours').toDate();
        this.request.to = moment().toDate();
        break;
      case 2:
        this.request.from = moment().startOf('day').toDate();
        this.request.to = moment().endOf('day').toDate();
        this.request.isToday = true;
        break;
      case 3:
        this.request.from = moment().subtract(1, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(1, 'days').endOf('day').toDate();
        break;
      case 4:
        this.request.from = moment().subtract(2, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(2, 'days').endOf('day').toDate();
        break;
      case 5:
        this.request.from = moment().subtract(3, 'days').startOf('day').toDate();
        this.request.to = moment().subtract(3, 'days').endOf('day').toDate();
        break;
      case 6:
        this.request.from = moment().startOf('week').toDate();
        this.request.to = moment().toDate();
        break;
      case 7:
        this.request.from = moment().subtract(1, 'weeks').startOf('week').toDate();
        this.request.to = moment().subtract(1, 'weeks').endOf('week').toDate();
        break;
      case 8:
        this.request.from = moment().startOf('month').toDate();
        this.request.to = moment().toDate();
        break;
      case 9:
        this.request.from = moment().subtract(1, 'months').startOf('month').toDate();
        this.request.to = moment().subtract(1, 'months').endOf('month').toDate();
        break;
    }
  }

  dateChanged(e: any) {
    /*this.currentFilter = 0;
    this.request.isToday = false;*/
  }

  changeDropDownBoxValue(args) {
    this.request.trailerOperationType = this.request.trailerOperationType
      .filter(o1 => !args.removedItems.find(o2 => o1.id === o2.id));
    this.request.trailerOperationType.push(...args.addedItems);
  }

}
